<template>
  <div class="jobs-wrapper">
    <Header />
    <TopMenu />
    <div
      v-if="$auth.ready()"
      id="jobs-body"
    >
      <div
        v-if="$auth.check()"
        class="you-are-here mb-0 text-left"
      >
        {{ youAreIn }}
      </div>
      <b-alert
        v-if="isError"
        show
        variant="warning"
        class="mb-0"
      >
        {{ $t('generic.something-went-wrong') }}... {{ $t('generic.limited-features') }}. {{ $t('generic.try-to-refresh') }}.
      </b-alert>
      <slot
        id="slot"
      />
    </div>
    <div v-if="!$auth.ready()">
      {{ $t('generic.loading') }}...
    </div>
    <Footer />
    <Footer2 />
  </div>
</template>

<script>
import Header from '@/components/jobs/Header.vue';
import TopMenu from '@/components/jobs/TopMenu.vue';
import Footer from '@/components/jobs/Footer.vue';
import Footer2 from '@/components/jobs/Footer2.vue';
import { mapState } from 'vuex';

export default {
  name: 'Default',
  components: {
    Header,
    TopMenu,
    Footer,
    Footer2
  },
  data() {
    return {
      isError: false,
      isLoaded: false
    }
  },
  computed: {
    ...mapState({
      Permissions: state => state.permissions.permissions,
    }),

    youAreIn() {
      return this.$route.meta.name ? this.$t(
        'main.you-are-in',
        'You are in {place}',
        {
          place: this.$t(this.$route.meta.name),
        }
      ) : '';
    }
  },
  async created() {
    if(this.$auth.check()) {
      await this.$store.dispatch('permissions/getPermissions')
        .then( () => {
          this.isError = false;
          this.isLoaded = true;
        })
        .catch( () => {
          this.isError = true;
        });
    } else {
      this.isLoaded = true;
    }
  },
}
</script>

<style lang="scss">
body {
    font-family: Helvetica,Arial,sans-serif;
    background: #c0c7cb !important;
}

.jobs-wrapper {
   @media screen and (min-width: 1200px) {
      width: 60%;
      margin: auto;
    }
}

#jobs-body {
    background: white;
    padding: 10px;
    min-height: calc(40vh);
}

.you-are-here {
    font-size: 11px;
    padding: 5px;
}

a {
  color: #658bc7 !important;
}

.body {
  padding: 25px 0;
  text-align: left;

  #title {
    font-weight: 600;
  }
}
</style>
